import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Exploring NextJS with a headless CMS, pt4 – CodeWithSwiz",
  "description": "NextJS getStaticProps, environment vars, and why you shouldn't use yarn link – all in this episode of #CodeWithSwiz",
  "published": "2020-09-10T00:00:00.000Z",
  "categories": "CodeWithSwiz, Livecoding, Technical",
  "hero": "./img/screenshot-1599748425535.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`getStaticProps, environment vars, and why you shouldn't use yarn link – all in this episode of #CodeWithSwiz`}</p>
    <p><em parentName="p">{`CodeWithSwiz is a twice-a-week live show. Like a podcast with video and fun hacking. Focused on experiments. `}<a parentName="em" {...{
          "href": "https://youtube.com/swizecteller"
        }}>{`Join live Wednesdays and Sundays`}</a></em></p>
    <lite-youtube {...{
      "videoid": "npI-NvSyywM",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`This was a fantastic streaming session. The thing works! You can do what I've been trying to build for the past 3 episodes 🤘`}</p>
    <p>{`Paste markdown into the new `}<inlineCode parentName="p">{`Markdown pasta 🍝`}</inlineCode>{` textarea and your article transforms into a full preview.`}</p>
    <ul>
      <li parentName="ul">{`youtube links turn into thumbnails`}</li>
      <li parentName="ul">{`tweets turn into screenshots`}</li>
      <li parentName="ul">{`code goes through `}<a parentName="li" {...{
          "href": "https://carbon.now.sh"
        }}>{`carbon.now.sh`}</a></li>
      <li parentName="ul">{`twitter names turn into links`}</li>
      <li parentName="ul">{`gifs are embedded`}</li>
    </ul>
    <p>{`Check it out live on `}<a parentName="p" {...{
        "href": "https://swiz-cms.vercel.app"
      }}>{`swiz-cms.vercel.app`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://swiz-cms.vercel.app"
      }}><img parentName="a" {...{
          "src": "/6c9811f89475041b8ef4f2ce7233c302/Preview-of-markdown-machineryc69438.gif",
          "alt": "Preview of markdown machinery"
        }}></img></a></p>
    <h2 {...{
      "id": "why-yarn-link-is-bad"
    }}>{`Why yarn link is bad`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/385e3fe2430fb72121a932663d2a775b/387f2/Cryptic-error-about-React-hooks4jghj1.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "65.47085201793722%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'262\\'%20viewBox=\\'0%200%20400%20262\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M40%20110v22h242V88H40v22m214%20114c-81%200-83%200-83%202l-2%203v2c2%200%202%202%202%2016v15h230v-14l-1-19v-5H254M1%20246v16h126l-2-2c-2-2-3-2-3-1-1%201-1%200-1-1v-3c-1%201-1%200-1-1l-1%202-1-9v-14h-5c-4%200-5%200-3-1%203-1-9-2-49-2l-38%201c1%202%200%202-7%202l-8-1c0-2-1-2-3-2H1v16\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/385e3fe2430fb72121a932663d2a775b/ca0a1/Cryptic-error-about-React-hooks4jghj1.webp 223w", "/static/385e3fe2430fb72121a932663d2a775b/75680/Cryptic-error-about-React-hooks4jghj1.webp 445w", "/static/385e3fe2430fb72121a932663d2a775b/8d1ba/Cryptic-error-about-React-hooks4jghj1.webp 890w", "/static/385e3fe2430fb72121a932663d2a775b/3838e/Cryptic-error-about-React-hooks4jghj1.webp 1335w", "/static/385e3fe2430fb72121a932663d2a775b/ebc20/Cryptic-error-about-React-hooks4jghj1.webp 1518w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/385e3fe2430fb72121a932663d2a775b/e92b6/Cryptic-error-about-React-hooks4jghj1.png 223w", "/static/385e3fe2430fb72121a932663d2a775b/e66bf/Cryptic-error-about-React-hooks4jghj1.png 445w", "/static/385e3fe2430fb72121a932663d2a775b/4ef49/Cryptic-error-about-React-hooks4jghj1.png 890w", "/static/385e3fe2430fb72121a932663d2a775b/4e814/Cryptic-error-about-React-hooks4jghj1.png 1335w", "/static/385e3fe2430fb72121a932663d2a775b/387f2/Cryptic-error-about-React-hooks4jghj1.png 1518w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/385e3fe2430fb72121a932663d2a775b/4ef49/Cryptic-error-about-React-hooks4jghj1.png",
                "alt": "Cryptic error about React hooks",
                "title": "Cryptic error about React hooks",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Cryptic error about React hooks`}</figcaption>{`
  `}</figure></p>
    <p>{`Much of our frustration budget was spent on this cryptic error. `}<em parentName="p">{`"Naughty naughty, calling hooks in a class component"`}</em></p>
    <p>{`You get this error when using `}<inlineCode parentName="p">{`yarn link`}</inlineCode>{` to develop libraries. Like when you have a piece of code you want to re-use in different projects.`}</p>
    <p>{`Library development relies on a combination of unit testing and integrating with your target project. I skip unit testing on stream because lazy ✌️`}</p>
    <p>{`You end up testing through integration.`}</p>
    <p>{`Best way to do that is to `}<inlineCode parentName="p">{`yarn link`}</inlineCode>{` (or `}<inlineCode parentName="p">{`npm link`}</inlineCode>{`) a local project into your code. That way changes are reflected immediately.`}</p>
    <p>{`And it leads to having multiple instances of React in the same project. One from your project, one from your library. Running instances in the browser that is. Happens with Vue too.`}</p>
    <p>{`You have to publish your library for every change 😩`}</p>
    <pre><code parentName="pre" {...{}}>{`1. see bug
2. make change and pepper console logs
3. yarn build
4. git commit
5. npm version patch
6. npm publish
7. change to target project
8. yarn add library
`}</code></pre>
    <p>{`For every change. Yeah it sucks. You learn to maximize debugging info for every change.`}</p>
    <h2 {...{
      "id": "environment-variables"
    }}>{`Environment variables`}</h2>
    <p>{`Environment variables are best used for configuring your API keys and other secrets. You shouldn't hardcode those and they shouldn't be part of your repository.`}</p>
    <p>{`NextJS has fantastic support out of the box. We kinda guessed on stream and it worked 🤘`}</p>
    <p>{`For local development, create a `}<inlineCode parentName="p">{`.env.local`}</inlineCode>{` file. `}<em parentName="p">{`Do not add to git`}</em></p>
    <pre><code parentName="pre" {...{}}>{`// /.env.local
GIPHY_API_KEY=value
`}</code></pre>
    <p>{`You can then read these variables on the server and during builds with `}<inlineCode parentName="p">{`process.env.GIPHY_API_KEY`}</inlineCode>{`.`}</p>
    <p>{`They're hidden from the browser for security reasons.`}</p>
    <p>{`For production and preview secrets, you should use Vercel's or Netlify's UI. They keep secrets encrypted and out of your codebase. Like it should be.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/c0923e2e0970f016e064305a50b21144/0f882/Prod-preview-dev-secrets-in-Vercel8f710i.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "59.64125560538116%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'239\\'%20viewBox=\\'0%200%20400%20239\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M77%2011c-1%201-2%202-4%201-3%200-3%200-3%202v3l-1-3c-1-2-4-3-6-1h-1l-6-1c-4%200-4%200-4%204l1%203%201-2%201-3%201%203%201%202%201-2%201-3%201%203%201%202%201-1h8l1%201%201-3%201-2%201%203c0%203%202%203%202-1v-3l1%202c1%207%203%203%202-4%200-2-2-1-2%200m14%2023l-1%203c0%202%203%203%204%201h1l2%201%201-1h1c0%201%201%202%202%201v-1l-1-1h2c2%202%205%202%207%201%201-1%201-1%201%201-1%203%200%203%201-1%202-2%202-2%202%200v2l1-2%201-2v4l1-2%201-1c0%202%205%202%205%201h2l1-2-6-1-8%201h-1l-3-1H94l-3-1M32%2069c0%203%202%205%203%203h6c0%202%200%202%203%200h6c2-2%202-2%202%200l1%203%201-3%201-1h3c1%201%201%201%201-1%201-2%200-2-2-2l-3%201h-4l-1%202v-3H36c-1-2-4-1-4%201m314%2066v10l1%209h40v-19l-20-1-21%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c0923e2e0970f016e064305a50b21144/ca0a1/Prod-preview-dev-secrets-in-Vercel8f710i.webp 223w", "/static/c0923e2e0970f016e064305a50b21144/75680/Prod-preview-dev-secrets-in-Vercel8f710i.webp 445w", "/static/c0923e2e0970f016e064305a50b21144/8d1ba/Prod-preview-dev-secrets-in-Vercel8f710i.webp 890w", "/static/c0923e2e0970f016e064305a50b21144/3838e/Prod-preview-dev-secrets-in-Vercel8f710i.webp 1335w", "/static/c0923e2e0970f016e064305a50b21144/8754d/Prod-preview-dev-secrets-in-Vercel8f710i.webp 1584w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c0923e2e0970f016e064305a50b21144/e92b6/Prod-preview-dev-secrets-in-Vercel8f710i.png 223w", "/static/c0923e2e0970f016e064305a50b21144/e66bf/Prod-preview-dev-secrets-in-Vercel8f710i.png 445w", "/static/c0923e2e0970f016e064305a50b21144/4ef49/Prod-preview-dev-secrets-in-Vercel8f710i.png 890w", "/static/c0923e2e0970f016e064305a50b21144/4e814/Prod-preview-dev-secrets-in-Vercel8f710i.png 1335w", "/static/c0923e2e0970f016e064305a50b21144/0f882/Prod-preview-dev-secrets-in-Vercel8f710i.png 1584w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c0923e2e0970f016e064305a50b21144/4ef49/Prod-preview-dev-secrets-in-Vercel8f710i.png",
                "alt": "Prod, preview, dev secrets in Vercel",
                "title": "Prod, preview, dev secrets in Vercel",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Prod, preview, dev secrets in Vercel`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "getstaticprops"
    }}>{`getStaticProps`}</h2>
    <p>{`Having env vars on the server and inside builds is great, but our `}<inlineCode parentName="p">{`<LetterBuilder>`}</inlineCode>{` plugin needed them in the browser.`}</p>
    <p>{`You can expose public vars in NextJS by prefixing with `}<inlineCode parentName="p">{`NEXT_PUBLIC`}</inlineCode>{`. I haven't tried if that works on Netlify.`}</p>
    <p>{`Our API key isn't public though. It's a true secret and should stay secret. You can see it on my stream because I'm a terrible person. `}<em parentName="p">{`And`}</em>{` because I can click a button to change it 😉`}</p>
    <p>{`We used `}<inlineCode parentName="p">{`getStaticProps`}</inlineCode>{` to read the key at build time and send it to our page as a React prop. This is insecure.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// /pages/index.js

export async function getStaticProps() {
    return {
        // populate props however you want
        props: {
            giphyAPIKey: process.env.GIPHY_API_KEY,
        },
    };
}

// ...

export default function Home({ giphyAPIKey }) {
`}</code></pre>
    <p>{`When you export `}<inlineCode parentName="p">{`getStaticProps`}</inlineCode>{` from your page, NextJS runs your method when building the page. Either for static rendering or their static generation magic.`}</p>
    <p>{`Those props are then baked into the render of your exported default component.`}</p>
    <p>{`Similar to Gatsby's `}<inlineCode parentName="p">{`staticQuery`}</inlineCode>{` and `}<inlineCode parentName="p">{`useStaticQuery`}</inlineCode>{` without the complication of GraphQL and far more flexible. You can use this method for anything you want. Even API requests.`}</p>
    <p>{`Make sure your props are serializable JSON ✌️`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      